function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  transform: "rotate(45 18 18)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.546875,23.90625 C17.0390625,23.90625 17.3984375,23.5546875 17.3984375,23.078125 C17.3984375,22.828125 17.3046875,22.6171875 17.140625,22.4609375 L15.3828125,20.6796875 L13.1171875,18.609375 L14.9375,18.71875 L24.40625,18.71875 C24.921875,18.71875 25.28125,18.359375 25.28125,17.8515625 C25.28125,17.3359375 24.921875,16.9765625 24.40625,16.9765625 L14.9375,16.9765625 L13.125,17.0859375 L15.3828125,15.015625 L17.140625,13.234375 C17.3046875,13.078125 17.3984375,12.8671875 17.3984375,12.6171875 C17.3984375,12.140625 17.0390625,11.7890625 16.546875,11.7890625 C16.3203125,11.7890625 16.109375,11.875 15.90625,12.0703125 L10.7734375,17.203125 C10.59375,17.375 10.4921875,17.609375 10.4921875,17.8515625 C10.4921875,18.0859375 10.59375,18.3203125 10.7734375,18.4921875 L15.9296875,23.640625 C16.1171875,23.8203125 16.3203125,23.90625 16.546875,23.90625 Z",
  fill: "#3C4043",
  fillRule: "nonzero"
}));

var SvgArrowUpLeft = function SvgArrowUpLeft(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "36px",
    viewBox: "0 0 36 36",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArrowUpLeft, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrow-up-left.6d35e474.svg";
export { ForwardRef as ReactComponent };